const ATTRIBUTE_KEYS = ['API', 'ACEA', 'ILSAC', 'OEM / Manufacturer Specifications'];

const MANUFACTURER_RULES = [
  ['BMW', /\bBMW\b/i],
  ['Mercedes-Benz', /\bMB\s/i],
  ['Volkswagen / Audi', /\bVW\s/i],
  ['GM', /\bGM\b|\bdexos/i],
  ['Ford', /\bFord\b/i],
  ['Porsche', /\bPorsche\b/i],
  ['Toyota', /\bToyota\b/i],
  ['Honda / Acura', /\bHonda\b|\bAcura\b/i],
  ['Renault', /\bRenault\b|\bRN\d/i],
  ['Volvo', /\bVolvo\b/i],
  ['Jaguar Land Rover', /Jaguar Land Rover|STJLR/i],
  ['Chrysler', /\bChrysler\b/i],
  ['Fiat', /\bFiat\b/i],
  ['Opel / Vauxhall', /Opel|Vauxhall/i],
  ['PSA', /\bPSA\b/i],
  ['Iveco', /\bIveco\b/i],
  ['Daihatsu', /\bDaihatsu\b/i],
  ['Hyundai / Kia', /\bHyundai\b|\bKia\b/i],
  ['Isuzu', /\bIsuzu\b/i],
  ['Lexus', /\bLexus\b/i],
  ['Mazda', /\bMazda\b/i],
  ['Mitsubishi', /\bMitsubishi\b/i],
  ['Nissan', /\bNissan\b/i],
  ['Subaru', /\bSubaru\b/i],
  ['Suzuki', /\bSuzuki\b/i],
];

export const getEngineOilSearchText = (product) => [
  product.sku,
  product.partNumber,
  product.name,
  product.description,
  ...Object.entries(product.attributes || {}).flat(),
].join(' ');

export const getSpecificationOptions = (products) => {
  const options = new Set();
  products.forEach((product) => {
    ATTRIBUTE_KEYS.forEach((key) => {
      String(product.attributes?.[key] || '')
        .split(',')
        .map((value) => value.trim())
        .filter(Boolean)
        .forEach((value) => options.add(value));
    });
  });
  return [...options].sort((a, b) => a.localeCompare(b, undefined, { numeric: true }));
};

export const getManufacturerOptions = (products) => {
  const corpus = products.map(getEngineOilSearchText).join(' ');
  return MANUFACTURER_RULES
    .filter(([, pattern]) => pattern.test(corpus))
    .map(([label]) => label);
};

export const matchesManufacturer = (product, manufacturer) => {
  if (!manufacturer) return true;
  const rule = MANUFACTURER_RULES.find(([label]) => label === manufacturer);
  return rule ? rule[1].test(getEngineOilSearchText(product)) : false;
};

